/** @format */

import React from "react";
import { FieldStackContext } from "./fieldStackContext";

const FieldStack = ({ children, className = "", gapClassName = "tw-gap-[18px]" }) => (
  <FieldStackContext.Provider value={true}>
    <div className={`tw-flex tw-flex-col ${gapClassName} ${className}`}>
      {children}
    </div>
  </FieldStackContext.Provider>
);

export default FieldStack;
